var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPowerbi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M40,41H8c-2.206,0-4-1.794-4-4V11c0-2.206,1.794-4,4-4h32c2.206,0,4,1.794,4,4v26 C44,39.206,42.206,41,40,41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M34,12.98H14.02c-2.2,0-4,1.79-4,4V30c0,1.86,1.27,3.42,2.98,3.86v-2.14 c-0.59-0.35-0.98-0.99-0.98-1.72V16.98c0-1.1,0.9-2,2-2H34c1.1,0,2,0.9,2,2V30c0,0.74-0.4,1.38-1,1.73v2.14c1.73-0.44,3-2.01,3-3.87 V16.98C38,14.77,36.21,12.98,34,12.98z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M16.5,28L16.5,28c0.828,0,1.5,0.672,1.5,1.5v5c0,0.828-0.672,1.5-1.5,1.5l0,0 c-0.828,0-1.5-0.672-1.5-1.5v-5C15,28.672,15.672,28,16.5,28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M21.5,22L21.5,22c0.828,0,1.5,0.672,1.5,1.5v11c0,0.828-0.672,1.5-1.5,1.5l0,0 c-0.828,0-1.5-0.672-1.5-1.5v-11C20,22.672,20.672,22,21.5,22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M26.5,25L26.5,25c0.828,0,1.5,0.672,1.5,1.5v8c0,0.828-0.672,1.5-1.5,1.5l0,0 c-0.828,0-1.5-0.672-1.5-1.5v-8C25,25.672,25.672,25,26.5,25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M31.5,18L31.5,18c0.828,0,1.5,0.672,1.5,1.5v15c0,0.828-0.672,1.5-1.5,1.5l0,0 c-0.828,0-1.5-0.672-1.5-1.5v-15C30,18.672,30.672,18,31.5,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPowerbi);
export default __webpack_public_path__ + "static/media/logo_powerbi.6f3d915774c62a7706874d69e49a3ffd.svg";
export { ForwardRef as ReactComponent };